module.exports = __webpack_public_path__ + "static/media/pill-icon-location-pin.034c0812.svg";